<template>
  <div>
    <img src="placeholders/lines.svg" width="100%" :alt="$t('template.new.metric_placeholder')" />
    <img src="placeholders/nps_choose.svg" width="100%" class="t-mt-md" :alt="$t('template.new.metric_placeholder')" />
    <div class="text-center q-mt-md">
      <div style="font-size: 14px; color: #828282">{{ subtitle }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    subtitle: String
  }
};
</script>
